<template>
  <div class="ex-separator" :class="{'dotted-style' : dotted}"></div>
</template>

<script>
export default {
  name: 'Separator',
  props: {
    dotted: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ui/Separator.vue